import { Link as RouterLink } from "react-router-dom";
import { ProductSummary } from "Pages/Products/styled";
import { SavingAccountData } from "Services/api/finance/interfaces";
import { MoneyFormat } from "Shared/MoneyFormat/MoneyFormat";
import { Accordion, Typography, AccordionDetails, Card, CardContent, Stack, CardActions, Button } from "@mui/material";
import ValueElement from "Shared/ValueElement/ValueElement";

export function SavingAccountSummary({ data }: { data: SavingAccountData }): JSX.Element {
  return (
    <Accordion defaultExpanded variant="outlined" sx={{ backgroundColor: "#F6F9F2", border: "none" }}>
      <ProductSummary>
        <Typography component="h2" sx={{ fontWeight: "bold" }}>
          Cuentas de ahorro
        </Typography>
      </ProductSummary>
      <AccordionDetails sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {data.items.map((item) => (
          <Card key={item.accountNumber}>
            <CardContent>
              <Stack sx={{ flexDirection: { md: "row" } }} flexWrap="wrap" justifyContent={"space-between"}>
                <ValueElement title={"Número de producto"} value={item.accountNumber} />
                <ValueElement
                  title={"Tipo de producto"}
                  value={<Typography sx={{ textTransform: "capitalize" }}>{item.accountType.toLowerCase()}</Typography>}
                />

                <Stack>
                  <Stack
                    flexWrap="wrap"
                    sx={{ flexDirection: { md: "row" } }}
                    gap="5px 15px"
                    justifyContent={"space-between"}
                  >
                    <Typography>
                      <strong>Balance:</strong>
                    </Typography>
                    <Typography>
                      <MoneyFormat amount={item.accountBalance} />
                    </Typography>
                  </Stack>
                  <Stack
                    flexWrap="wrap"
                    sx={{ flexDirection: { md: "row" } }}
                    gap="5px 15px"
                    justifyContent={"space-between"}
                  >
                    <Typography>
                      <strong>Balance disponible:</strong>
                    </Typography>
                    <Typography>
                      <MoneyFormat amount={item.availableAccountBalance} />
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </CardContent>
            <CardActions>
              <Button component={RouterLink} to={`/ahorro/${item.accountNumber}`}>
                Ver detalle de producto
              </Button>
            </CardActions>
          </Card>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
